import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
// import { useSelector } from "react-redux";
import _ from "lodash";
import Checkbox from "../../framework/Checkbox";
import Button from "../../framework/Button";
import Shortcut from "../../framework/Shortcut";
import GlobalContext from "../../framework/GlobalContext";
import SelectInput from "../../framework/SelectInput";
import TextInput from "../../framework/TextInput";
import NumberInput from "../../framework/NumberInput";
import ChipInputSelect from "../../framework/ChipInputSelect";
import Filters from "../../common/reports/Filters";
import FilterGroup from "../../common/reports/FilterGroup";
import FilterItem from "../../common/reports/FilterItem";
import { isEmpty } from "../../utils/utils";
import { createFilterParam } from "../../common/reports/reportUtils";
import {
  LIKE,
  BOOL,
  STRING,
  SIMILARTO,
} from "../../common/reports/reportConstants";
import { medicineScheduleTypes } from "../../utils/constant";
import { searchGlobalMedicine } from "../../services/medicine-services";
import { searchCategories } from "../../services/category-services";

const ProductReportFilter = ({
  reportRef,
  onFilterShow,
  refreshData = false,
  // applyFilters = () => {},
  applyFilterOnMount = true,
}) => {
  const [productOptions, setProductOptions] = useState([]);
  const [product, setProduct] = useState("");
  const [manufacturer, setManufacturer] = useState("");
  const [selectedScheduleType, setSelectedScheduleType] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [filterOnInStock, setFilterOnInStock] = useState(false);
  const [limit, setLimit] = useState(100);
  const [orderBy] = useState([
    { fieldName: "medicineNameDetailed", orderType: "asc" },
  ]);
  // const { data } = useSelector((state) => {
  //   return state.commonReducer.tabs[state.commonReducer?.activeTabIndex];
  // });
  const apr_filter_product_name_ref = useRef();
  const applyFilterRef = useRef();
  const { setCurrentComponent } = useContext(GlobalContext);
  const applyFilterHandler = useCallback(
    (isFilterChanged = false) => {
      let filters = [];
      let result = {};
      if (!isEmpty(product)) {
        filters.push(
          createFilterParam(
            "medicineNameDetailed",
            `${product}`,
            "string",
            LIKE
          )
        );
      }
      if (!isEmpty(manufacturer)) {
        filters.push(
          createFilterParam(
            "manufacturerName",
            `${manufacturer}`,
            "string",
            LIKE
          )
        );
      }
      if (selectedScheduleType.length) {
        filters.push(
          createFilterParam(
            "genericType",
            selectedScheduleType
              .map((type) => type.label.toLowerCase())
              .join("|"),
            STRING,
            SIMILARTO
          )
        );
      }
      if (selectedCategory.length) {
        filters.push(
          createFilterParam(
            "categoryName",
            selectedCategory.map((c) => c.label.toLowerCase()).join("|"),
            STRING,
            SIMILARTO
          )
        );
      }
      if (filterOnInStock) {
        filters.push(createFilterParam("inStock", filterOnInStock, BOOL));
      }
      if (orderBy?.length) {
        result.orderBy = orderBy;
      }
      result.filters = filters;
      result.isFilterChanged = isFilterChanged;
      if (!isEmpty(limit)) {
        result.limit = limit;
      }
      reportRef.current?.applyFilters(result);
      // return result;
      // applyFilters(result, {
      //   selectedCategory,
      //   filterOnInStock,
      //   limit,
      //   manufacturer,
      //   product,
      //   selectedScheduleType,
      // });
    },
    [
      filterOnInStock,
      limit,
      manufacturer,
      orderBy,
      product,
      reportRef,
      selectedCategory,
      selectedScheduleType,
    ]
  );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  let debounce = useCallback(
    _.debounce(() => {
      applyFilterHandler();
    }, 300),
    []
  );
  const filterListener = useCallback((event) => {
    const key = event.key.toLowerCase();
    const ctrl = event.ctrlKey;
    if (ctrl && key === "enter") {
      return applyFilterRef.current.click();
    }
  }, []);

  const filterContent = (
    <>
      <FilterGroup>
        <FilterItem>
          <SelectInput
            id="apr_filter_product_name"
            label="Product"
            ref={apr_filter_product_name_ref}
            options={productOptions}
            getOptionLabel={(option) => option.label || option}
            isOptionEqualToValue={(option, value) => {
              return option.label === value.label || value === "";
            }}
            onFocus={() => setCurrentComponent("apr_filter_product_name")}
            freeSolo
            onChange={(e, values) => {
              setProduct(values.label);
            }}
            value={product}
            onInputChange={(e) => {
              if (!e) return;
              setProduct(e.target.value);
              setProductOptions([]);
              if (!e?.target?.value) setProduct(null);
              if (e?.target?.value?.length > 2) {
                searchGlobalMedicine(`search=${e.target.value.trim()}`).then(
                  (resp) => {
                    let updatedResp = [];
                    resp.result.forEach((prod) => {
                      updatedResp.push({
                        id: prod.medicineId,
                        label: prod.medicineNameDetailed,
                      });
                    });
                    setProductOptions(updatedResp);
                  }
                );
              }
            }}
            markers={JSON.stringify({
              up: "apr_filter_product_name",
              down: "apr_filter_manufacturer",
              right: "apr_filter_manufacturer",
              left: "apr_filter_product_name",
            })}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <TextInput
            id="apr_filter_manufacturer"
            label="Manufacturer"
            value={manufacturer}
            onChange={(e) => {
              setManufacturer(e.target.value);
            }}
            onFocus={() => {
              setCurrentComponent("apr_filter_manufacturer");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "apr_filter_product_name",
                down: "apr_filter_schedule_type",
                right: "apr_filter_schedule_type",
                left: "apr_filter_product_name",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <ChipInputSelect
            id="apr_filter_schedule_type"
            label="Schedule Type"
            multiple={true}
            isOptionEqualToValue={(option, value) => {
              return option.id === value.id;
            }}
            value={selectedScheduleType}
            onChange={(e, newValue) => {
              setSelectedScheduleType(newValue);
            }}
            limitTags={2}
            filterSelectedOptions={false}
            blurOnSelect={false}
            disableCloseOnSelect
            onFocus={() => setCurrentComponent("apr_filter_schedule_type")}
            options={medicineScheduleTypes}
            markers={JSON.stringify({
              up: "apr_filter_manufacturer",
              down: "apr_filter_category",
              right: "apr_filter_category",
              left: "apr_filter_manufacturer",
            })}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <ChipInputSelect
            id="apr_filter_category"
            label="Category"
            multiple={true}
            isOptionEqualToValue={(option, value) => {
              return option.id === value.id;
            }}
            value={selectedCategory}
            filterSelectedOptions={false}
            blurOnSelect={false}
            disableCloseOnSelect
            limitTags={2}
            onFocus={() => setCurrentComponent("apr_filter_category")}
            options={categoryOptions}
            onChange={(e, newValue) => {
              setSelectedCategory(newValue);
            }}
            markers={JSON.stringify({
              up: "apr_filter_schedule_type",
              down: "apr_filter_in_stock",
              right: "apr_filter_in_stock",
              left: "apr_filter_schedule_type",
            })}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <Checkbox
            id="apr_filter_in_stock"
            label="In Stock"
            onChange={(e) => setFilterOnInStock(e.target.checked)}
            onFocus={() => {
              setCurrentComponent("apr_filter_in_stock");
            }}
            checked={filterOnInStock}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "apr_filter_category",
                down: "apr_filter_limit",
                right: "apr_filter_limit",
                left: "apr_filter_category",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <NumberInput
            label="Limit"
            id="apr_filter_limit"
            value={limit}
            onFocus={() => setCurrentComponent("apr_filter_limit")}
            onValueChange={(values, e) => {
              setLimit(values.floatValue);
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "apr_filter_in_stock",
                left: "apr_filter_in_stock",
                down: "apr_apply_filter_button",
                right: "apr_apply_filter_button",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
    </>
  );
  const filterFooter = (
    <>
      <FilterGroup>
        <FilterItem>
          <Button
            id="apr_apply_filter_button"
            label="Apply"
            ref={applyFilterRef}
            endIcon={<Shortcut keys={["Ctrl", "Enter"]} />}
            onClick={() => {
              applyFilterHandler(true);
            }}
            markers={JSON.stringify({
              up: "apr_filter_limit",
              left: "apr_filter_limit",
              right: "apr_filter_product_name",
              down: "apr_filter_product_name",
            })}
          />
        </FilterItem>
      </FilterGroup>
    </>
  );
  // useEffect(() => {
  //   if (refreshData) {
  //     applyFilterHandler();
  //   }
  // }, [applyFilterHandler, refreshData]);
  useEffect(() => {
    if (onFilterShow) {
      apr_filter_product_name_ref?.current.focus({ preventScroll: true });
      // setCurrentComponent("apr_filter_product_name");
    }
  }, [onFilterShow]);
  useEffect(() => {
    if (onFilterShow) document.addEventListener("keyup", filterListener, false);
    return () => {
      document.removeEventListener("keyup", filterListener, false);
    };
  }, [filterListener, onFilterShow]);
  useEffect(() => {
    if (applyFilterOnMount) debounce();
    return () => {
      debounce.cancel();
    };
  }, [applyFilterOnMount, debounce]);
  // useEffect(() => {
  //   if (!applyFilterOnMount) {
  //     if (data?.filters) {
  //       setProduct(data.filters.product);
  //       setSelectedCategory(data.filters.selectedCategory);
  //       setManufacturer(data.filters.manufacturer);
  //       setLimit(data.filters.limit);
  //       setSelectedScheduleType(data.filters.selectedScheduleType);
  //       setFilterOnInStock(data.filters.filterOnInStock);
  //     }
  //   }
  // }, [applyFilterOnMount, data]);
  useEffect(() => {
    if (onFilterShow) {
      searchCategories().then((response) => {
        let updatedResp = [];
        response.result.rows.forEach((cat) => {
          updatedResp.push({
            ...cat,
            id: cat.categoryId,
            label: cat.categoryName,
          });
        });
        setCategoryOptions(updatedResp);
      });
    }
  }, [onFilterShow]);

  return <Filters filterContent={filterContent} filterFooter={filterFooter} />;
};

export default ProductReportFilter;
